import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "my-sidebar flex flex-col flex-grow justify-between",
  style: {"background-color":"#b8b1a9"}
}
const _hoisted_2 = {
  class: "flex flex-col justify-between flex-grow",
  style: {"background-color":"#b8b1a9"}
}
const _hoisted_3 = { class: "flex flex-col flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "flex pl-2.5 mb-7 mr-7 mt-7",
  style: {"margin-top":"55px!important"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "logo_sel1.png",
    alt: "Selenia Italia"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" HOME ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" LISTA MACCHINE ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" REPORT ERRORI ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" AZIONI MACCHINE ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Amministrazione ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Account ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Macchine ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Strumenti sviluppatore ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Log messaggi ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Log eventi ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Documentazione ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Chiudi Menu ")
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_19 = { class: "flex justify-evenly items-center space-x-3 pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBarItem = _resolveComponent("SideBarItem")!
  const _component_SideBarLink = _resolveComponent("SideBarLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SideBarItem, {
          showLabel: _ctx.isOpen,
          style: {"background-color":"#b8b1a9"}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["showLabel"]),
        (!_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_SideBarLink, {
              key: 0,
              to: "/",
              showLabel: _ctx.isOpen,
              icon: "fas fa-home",
              class: "bg-light vocemenu"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["showLabel"]))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_SideBarLink, {
              key: 1,
              to: "/machine-list",
              showLabel: _ctx.isOpen,
              icon: "fas fa-desktop",
              class: "bg-light vocemenu"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["showLabel"]))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn && _ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_SideBarLink, {
              key: 2,
              to: "/reportErrori",
              showLabel: _ctx.isOpen,
              icon: "fas fa-exclamation",
              class: "bg-light vocemenu"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["showLabel"]))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn && _ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_SideBarLink, {
              key: 3,
              to: "/azioniMacchine",
              showLabel: _ctx.isOpen,
              icon: "fas fa-upload",
              class: "bg-light vocemenu"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["showLabel"]))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn && _ctx.isAdmin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createVNode(_component_SideBarItem, {
                showLabel: _ctx.isOpen,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSection('manage'))),
                icon: "fas fa-book-open",
                class: _normalizeClass({'is-selected': _ctx.section === 'manage'})
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["showLabel", "class"]),
              (_ctx.section === 'manage')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 0,
                    to: "/manage/accounts",
                    showLabel: _ctx.isOpen,
                    icon: "fas fa-align-left",
                    class: _normalizeClass({'is-selected': _ctx.section === 'manage'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true),
              (_ctx.section === 'manage')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 1,
                    to: "/manage/machines",
                    showLabel: _ctx.isOpen,
                    icon: "fas fa-align-left",
                    class: _normalizeClass({'is-selected': _ctx.section === 'manage'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLoggedIn && _ctx.isAdmin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createVNode(_component_SideBarItem, {
                showLabel: _ctx.isOpen,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSection('developer'))),
                icon: "fas fa-flask",
                class: _normalizeClass({'is-selected': _ctx.section === 'developer'})
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["showLabel", "class"]),
              (_ctx.section === 'developer')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 0,
                    showLabel: _ctx.isOpen,
                    to: "/developer",
                    icon: "fas fa-flask",
                    class: _normalizeClass({'is-selected': _ctx.section === 'developer'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true),
              (_ctx.section === 'developer')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 1,
                    to: "/developer/log",
                    showLabel: _ctx.isOpen,
                    icon: "fas fa-align-left",
                    class: _normalizeClass({'is-selected': _ctx.section === 'developer'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true),
              (_ctx.section === 'developer')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 2,
                    to: "/developer/events",
                    showLabel: _ctx.isOpen,
                    icon: "fas fa-align-left",
                    class: _normalizeClass({'is-selected': _ctx.section === 'developer'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true),
              (_ctx.section === 'developer')
                ? (_openBlock(), _createBlock(_component_SideBarLink, {
                    key: 3,
                    to: "/developer/documentation",
                    showLabel: _ctx.isOpen,
                    icon: "fas fa-list-alt",
                    class: _normalizeClass({'is-selected': _ctx.section === 'developer'})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["showLabel", "class"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_SideBarItem, {
          showLabel: _ctx.isOpen,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleSidebar'))),
          class: "bg-lighter vocemenu",
          icon: "fas fa-arrows-alt-h"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["showLabel"])
      ]),
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.version) + " " + _toDisplayString(_ctx.timestamp), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}